// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '391fc35',
  branch: 'preproduction',
  buildDate: '2026-11-04T11:24:18.965Z',
  dirty: true,
} as const;
